import cx from 'classnames';
import Image, { ImageProps } from 'next/image';
import { MouseEventHandler, useMemo } from 'react';

import { HtmlContent } from '../../../../domains/Layout/HtmlContent/HtmlContent';
import { removeHtmlTags } from '../../../../shared/utilities/removeHtmlTags';
import { IconArrowRight } from '../../icons/ArrowRight';
import { RATIO, Ratio } from '../../ratio/Ratio';

import style from './TravelGuideArticleCard.module.css';

export type TravelGuideArticleCardProps = {
    title: string;
    summary: string;
    articleUrl: string;
    onClick?: MouseEventHandler<HTMLElement>;
    ctaLabel: string;
    image: ImageProps & {
        sizes: ImageProps['sizes'];
    };
};

export function TravelGuideArticleCard({
    title,
    summary,
    articleUrl,
    onClick,
    image,
    ctaLabel,
}: TravelGuideArticleCardProps) {
    const summaryWithoutHtml = useMemo(() => {
        return removeHtmlTags(summary);
    }, [summary]);

    const handleClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
        if (onClick) {
            onClick(event);
        }
    };

    return (
        <div className={style.card}>
            <Ratio ratio={TravelGuideArticleCard.PICTURE_RATIO} className={style.cover}>
                <Image {...image} fill alt={image.alt} className="imageCover" />
            </Ratio>
            <div className={style.cardBody}>
                <div className={style.cardBodyContent}>
                    <a href={articleUrl} onClick={handleClick} className={style.title}>
                        {title}
                    </a>
                    <div className={style.summaryWrapper}>
                        <div className={style.summary}>
                            <HtmlContent htmlContent={summaryWithoutHtml} />
                        </div>
                    </div>
                </div>
                <div className={cx(style.cta, 'font-body-bold')}>
                    {ctaLabel} <IconArrowRight className={style.ctaIcon} />
                </div>
            </div>
        </div>
    );
}

TravelGuideArticleCard.PICTURE_RATIO = RATIO['3/1'];
